import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotTopicsSection from './components/HotTopicsSection';
import CategoryGrid from './components/CategoryGrid';
import LatestArticles from './components/LatestArticles';
import CTASection from './components/CTASection';

export default function Home() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '今日看料是什么网站？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '今日看料是一个中文娱乐资讯聚合平台，专注于网红爆料、娱乐圈八卦、热点事件追踪等实时内容，为吃瓜群众提供一站式热点资讯服务。',
        },
      },
      {
        '@type': 'Question',
        name: '如何获取今日看料最新地址和入口？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '今日看料官方网址为 www.jinrikankan.com，您可以直接访问获取最新内容。我们也提供今日看料App下载，方便您随时随地追踪热点。',
        },
      },
      {
        '@type': 'Question',
        name: 'PP料今日最新价格在哪里查看？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'PP料今日最新价格可以在今日看料网的PP料专区查看，我们每日更新PP料市场行情、价格走势分析和行业动态，为业内人士提供参考。',
        },
      },
      {
        '@type': 'Question',
        name: '今日看料的内容更新频率如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '今日看料保持全天候内容更新，编辑团队7x24小时追踪热点事件，确保您第一时间获取最新爆料和资讯。',
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="今日看料 | 今日看料网入口 - 吃瓜一线热点追踪站"
        description="今日看料网入口聚合，提供今日看料app下载和最新地址。覆盖pp料今日最新价格、黑料今日、网红爆料等实时内容，吃瓜群众的一线热点追踪站。"
        keywords="今日看料,今日看料入口,今日看料下载,今日看料最新地址,pp料今日最新价格,黑料今日,每日看料,今日看料官网,今日看料app,吃瓜一线,网红爆料"
        canonicalUrl="https://www.jinrikankan.com/"
        ogType="website"
        pageType="webpage"
        schemaData={faqSchema}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />
          <HotTopicsSection />
          <CategoryGrid />
          <LatestArticles />
          <CTASection />
        </main>

        <Footer />
      </div>
    </>
  );
}